<template>
  <div class="setAdmin">
    <el-dialog
      title="绑定分账合约"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="880px"
      :before-close="close"
    >
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="id" align="center" width="200" prop="contractId" />
        <el-table-column label="编号" align="center" prop="contractNo" />
        <el-table-column label="合约名称" align="center" prop="contractName" />
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="handleChoose(row)">选择</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getContracts,
  bindContractId,
} from "@/api/organization";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      data: [],
      id: '',
    };
  },
  methods: {
    // 删除
    handleChoose({ contractId, contractName }) {
      this.$confirm("确认要绑定该分账合约吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            id: this.id,
            contractName,
            contractId
          }
          bindContractId(params).then(({ code }) => {
            if (code === 0) {
              this.$message.success('绑定成功!')
              this.$emit('refresh')
              this.close()
            }
          })
        })
        .catch(() => {});
    },
    async handleGetContracts() {
      this.loading = true;
      const res = await getContracts()
      this.data = res.data || [];
      this.loading = false;
    },
    // 初始化
    init(id) {
      this.id = id || "";
      this.handleGetContracts();
      this.dialogVisible = true;
    },
    // 关闭
    close() {
      this.dialogVisible = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.setAdmin {
  .title {
    margin: 0px 0 10px;
  }
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
